import { render, staticRenderFns } from "./ListaInformativa.vue?vue&type=template&id=7953b0b5"
import script from "./ListaInformativa.vue?vue&type=script&lang=js"
export * from "./ListaInformativa.vue?vue&type=script&lang=js"
import style0 from "./ListaInformativa.vue?vue&type=style&index=0&id=7953b0b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports